const comunidade = angular.module('comunidade', [])

comunidade.config(['$stateProvider', function($stateProvider) {

    const routes = [
        {
            name: 'cliente.comunidade',
            url: '/comunidade',
            params: { showGlobalLoading: { dynamic: true, value: true }},
            component: 'comunidade.comunidadeComponent'
        }
    ];

    routes.forEach($stateProvider.state);
}]);